<template>
  <div>
    <h2>编辑热门</h2>
    <domeSort />
  </div>
</template>

<script>
import domeSort from "./domeSort";
export default {
  components: { domeSort },
  data() {
    return {};
  },
  created() {},

  methods: {},
};
</script>

<style >
</style>



// WEBPACK FOOTER //
// src/views/service/setHotLIst.vue